const initialState = {
  results: [],
  total: 0,
  totalResults: 0
}

const imports = (state = initialState, action) => {
  switch (action.type) {
    case 'RECEIVE_IMPORTS':
      return action.imports

    default:
      return state
  }
}

export default imports